var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLibrary = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5.833h8.333A1.666 1.666 0 0117.5 2.5v13.333l-1.667-.725V2.5h-10A1.667 1.667 0 017.5.833zm5 15.834V5.833H4.167v10.834l4.166-1.817 4.167 1.817zm0-12.5c.925 0 1.667.75 1.667 1.666v13.334l-5.834-2.5-5.833 2.5V5.833a1.667 1.667 0 011.667-1.666H12.5z"
  })));
};
export default SvgLibrary;